import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  Button,
  notification,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import {
  RequisitadoRc,
  getAllRequisitoSemOrdemCompraProjeto,
  RequisitadoSemOrdemCompra,
  RequisitadoComOrdemCompra,
  getAllRequisitoComOrdemCompraProjeto,
  getAllRequisitoProjeto,
} from '@app/api/crf/crfRequisitadoOc';
import FormTableRequisitadoCompraProjeto from './FormTableRequisitadoCompraProjeto';
import FormTableRequisitadoCompraOrdemCompraProjeto from './FormTableRequisitadoCompraOrdemCompraProjeto';

interface FormResumoCapexProps {
  projetoId: string;
}

const { Panel } = Collapse;

const FormTableRequisitadoProjeto = (props: FormResumoCapexProps) => {
  const { projetoId } = props;
  const [requisitoCompra, setRequisitoCompra] = useState<RequisitadoSemOrdemCompra[]>();
  const [requisitoComOrdemCompra, setRequisitoComOrdemCompra] = useState<RequisitadoComOrdemCompra[]>();

  const [valorTotal, setValorTotal] = useState<string>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [crfContaContabilCcId, setCrfContaContabilCcId] = useState<string>();
  const [selectedRowKeys, setSelectedRowKeys] = useState<RequisitadoRc>();
  const [chamarEventoBotao, setChamarEventoBotao] = useState<boolean>(false);
  const [requisitadoRc, setrequisitadoRc] = useState<RequisitadoRc[]>();

  const [displayWidgetRequisitado, setDisplayWidgetRequisitado] = useState({ display: 'none' });

  const getRequisitadoRc = async () => {
    const resultRequisitado = await getAllRequisitoProjeto(projetoId);
    if (resultRequisitado) {
      setrequisitadoRc(resultRequisitado);
      if (resultRequisitado && resultRequisitado.length) {
        var requisitado = resultRequisitado[resultRequisitado.length - 1];
        if (requisitado)
          setValorTotal(requisitado.valorTotalFormatado);
      }
    }
  };

  useEffect(() => {
    getRequisitadoRc();
    setDisplayWidgetRequisitado({ display: 'none' });
  }, [])

  useEffect(() => {
    var codigoRequisitado = (new URLSearchParams(window.location.search)).get("codigoPacote");
    if (codigoRequisitado != undefined && requisitadoRc) {
      const result = requisitadoRc.filter((ordem) => ordem.codigoPacote === codigoRequisitado);
      if (result != undefined && result[0] != undefined) {
        setSelectedRowKeys(result[0]);
      }
    }
  }, [requisitadoRc]);


  useEffect(() => {
    if (selectedRowKeys != undefined) {
      setResultadoSelecionado(`${selectedRowKeys.index}`);
      setCrfContaContabilCcId(selectedRowKeys.crfContaContabilCcId);
      setChamarEventoBotao(true);
    }
  }, [selectedRowKeys]);

  useEffect(() => {
    if (chamarEventoBotao == true)
      verRequisitado();
  }, [chamarEventoBotao]);


  const handleTabelaSemOrdemRequistado = (result: RequisitadoSemOrdemCompra[], st: any) => {
    if (result && result.length > 0) {
      setRequisitoCompra(result);
      setDisplayWidgetRequisitado({ display: 'block' });
    } else {
      setRequisitoCompra([]);
    }
  };

  const handleTabelaComOrdemRequistado = (result: RequisitadoComOrdemCompra[], st: any) => {
    if (result && result.length > 0) {
      setRequisitoComOrdemCompra(result);
      setDisplayWidgetRequisitado({ display: 'block' });
    } else {
      setRequisitoComOrdemCompra([]);
    }
  };

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '2%',
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'codigoContaContabil',
        width: '2%',
      },
      {
        title: 'Código Agrupador',
        dataIndex: 'codigoAgrupador',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'nome',
        width: '55%',
      },
      {
        title: 'Status Requisitado',
        dataIndex: 'rcStatus',
        width: '15%',
      },
      {
        title: 'Valor Requisitado',
        dataIndex: 'valorTotalCurrency',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'requisicaoCompraValorTotalFormatado',
            width: '1%',
          },
        ],
      },
    ] as InlineEditColumnProps<RequisitadoRc>[];
  };

  const rowSelection = {

    onChange: (selectedRowKeys: any, selectedRows: any) => {
      var obj = selectedRows[0];
      if (selectedRows) {
        setCrfContaContabilCcId(obj.crfContaContabilCcId);
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any }) => (
      {
        disabled: record.name === 'Disabled User',
        name: record.name,
      }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio',
  };

  const verRequisitado = () => {
    if (crfContaContabilCcId) {
      const getRequisitadoCompra = async (id: string) => {
        const result = await getAllRequisitoSemOrdemCompraProjeto(id);
        if (result) {
          handleTabelaSemOrdemRequistado(result, "{ display: 'block' }");
        }
      };

      const getRequisitadoComOrdemCompra = async (id: string) => {
        const result = await getAllRequisitoComOrdemCompraProjeto(id);
        if (result) {
          handleTabelaComOrdemRequistado(result, "{ display: 'block' }");
        }
      };

      getRequisitadoCompra(crfContaContabilCcId);
      getRequisitadoComOrdemCompra(crfContaContabilCcId);
    } else {
      notification.error('Você deve selecionar um item');
    }
  };

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Resumo Requisitado" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                true && (
                  <Button
                    type="primary"
                    title="VER REQUISITADO"
                    icon="data-database"
                    onClick={() => {
                      verRequisitado();
                    }}
                  />
                ),
              ]}>
              <Row>
                <Table
                  id={"tabelaRequisitadoProjeto"}
                  rowKey="index"
                  columns={customColumns()}
                  dataSource={requisitadoRc}
                  rowSelection={{
                    ...rowSelection,
                  }}
                />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>

      <FormTableRequisitadoCompraProjeto
        requisitoCompra={requisitoCompra || []}
        projetoId={projetoId}
        style={displayWidgetRequisitado}
      />
      <FormTableRequisitadoCompraOrdemCompraProjeto
        requisitoComOrdemCompra={requisitoComOrdemCompra || []}
        projetoId={projetoId}
        style={displayWidgetRequisitado}
      />
    </>
  );
};

export default FormTableRequisitadoProjeto;
